import { useCallback } from 'react'

import { useNavigate, useParams } from 'react-router'

import Page from 'app/layout/Page'
import { organizationProfile } from 'app/lib/routes'
import { PostPlanBody } from 'app/models/Organization'
import { OrganizationRoute } from 'app/models/scribe.models'
import {
  useAddOrganizationPlanMutation,
  useGetCoBrandsQuery,
  useGetFeaturesQuery,
  useGetOrganizationPlansQuery,
} from 'app/redux/scribeApi'

import { PlanForm, PlanFormSchema } from './PlanForm'

export const AddPlanPage: React.FC = () => {
  const navigate = useNavigate()
  const { organizationId } = useParams() as OrganizationRoute
  const { data: coBrandsResponse } = useGetCoBrandsQuery({})
  const { data: features } = useGetFeaturesQuery({})
  const {
    data: existingPlans,
    isLoading: isLoadingPlans,
    isError: isPlansError,
  } = useGetOrganizationPlansQuery({ organizationId })

  const shouldShowForm = existingPlans || isPlansError

  const [addPlan, { isLoading }] = useAddOrganizationPlanMutation()

  const navigateToOrganizationProfile = useCallback(() => {
    navigate(organizationProfile.get(organizationId))
  }, [navigate, organizationId])

  const onSubmit = useCallback(
    (params: PlanFormSchema) => {
      const addPlanBody: PostPlanBody = {
        name: { en: params.name, fr: params.name },
        description: { en: params.name, fr: params.name },
        label: params.label,
        charge_price: params.cost,
        charge_strategy: params.model,
        is_default: params.default,
        features: params.services,
      }

      if (params.cobrand) {
        addPlanBody.cobrand_id = params.cobrand
      }

      addPlan({ organizationId, body: addPlanBody }).unwrap().then(navigateToOrganizationProfile)
    },
    [organizationId, addPlan, navigateToOrganizationProfile],
  )

  return (
    <Page isLoading={isLoading || isLoadingPlans}>
      {shouldShowForm && (
        <PlanForm
          onCancel={navigateToOrganizationProfile}
          onSubmit={onSubmit}
          availableFeatures={features ?? []}
          coBrandResponse={coBrandsResponse}
          initialValues={existingPlans?.length === 0 ? { default: true } : undefined}
        />
      )}
    </Page>
  )
}
